module.exports = __webpack_public_path__ + "media/src/images/top_covers/April_06-81d0722c366e656593dd2b9ac2070321.png";